export default function(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.15.9@element-ui/src/utils/merge.js
// module id = 566
// module chunks = 64